export const getAuthUrl = (locale: string, path: string = '') => {
    // Use explicit environment variable for production checking
    // or default to localhost if not in production.
    const isProduction = process.env.NODE_ENV === 'production';

    // Define base domains
    const devDomain = 'http://app.localhost:3000';
    const prodDomain = 'https://app.ecommaps.com';

    const baseUrl = isProduction ? prodDomain : devDomain;

    // Ensure path starts with / if not empty and not query param
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    // Construct full URL: Base + /locale + path
    // Example: https://app.ecommaps.com/ar/signup?plan=pro
    return `${baseUrl}/${locale}${cleanPath}`;
};

export const getMarketingUrl = (locale: string) => {
    const isProduction = process.env.NODE_ENV === 'production';

    // Marketing site domains (no 'app' subdomain)
    const devDomain = 'http://localhost:3000';
    const prodDomain = 'https://ecommaps.com';

    const baseUrl = isProduction ? prodDomain : devDomain;

    return `${baseUrl}/${locale}`;
};
